import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import { getCookies } from '../../hooks/useCookies';
import styles from './ToggleButton.module.scss';
import envValues from '../../enviornment';

function ToggleButtonOnOff({
  value,
  id,
  onMessage,
  offMessage,
  adminPatchBaseUrl,
  onToggleSuccess,
  beforeToggle,
}) {
  const [isOff, setIsOff] = useState(false);

  useEffect(() => {
    setIsOff(value);
  }, [value]);

  const handleButtonClick = () => {
    const nextActive = !isOff;
    if (beforeToggle && beforeToggle(nextActive) === false) {
      return;
    }
    let message;
    if (isOff) {
      message = offMessage;
    } else {
      message = onMessage;
    }
    confirmAlert({
      title: 'Confirm Status Change',
      message,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            const previous = isOff;
            setIsOff(nextActive);

            if (adminPatchBaseUrl && id) {
              axios
                .patch(
                  `${adminPatchBaseUrl}/${id}`,
                  { isActive: nextActive },
                  {
                    headers: {
                      Authorization: `Bearer ${getCookies('Token')}`,
                      'Content-Type': 'application/json; charset=utf-8',
                    },
                  }
                )
                .then(() => {
                  toast.success('Status updated successfully');
                  if (onToggleSuccess) onToggleSuccess();
                })
                .catch((err) => {
                  setIsOff(previous);
                  toast.error(
                    err.response?.data?.message || err.message || 'Failed to update status'
                  );
                });
              return;
            }

            const headers = {
              'Content-Type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*',
            };
            const body = { token: getCookies('Token'), userid: id, active: nextActive };
            axios
              .post(`${envValues.REACT_APP_API_ENDPOINT}/auth/toggle-change`, body, { headers })
              .then(() => {
                toast.success('Status updated successfully');
                if (onToggleSuccess) onToggleSuccess();
              })
              .catch(() => {
                setIsOff(previous);
                toast.error('Failed to update status');
              });
          },
        },
        {
          label: 'No',
          // onClick: () => alert("Click No")
        },
      ],
    });
  };
  return (
    <div className="col ">
      <label className={styles.switch}>
        <input type="checkbox" checked={isOff} onClick={handleButtonClick} />
        <span className={styles.slider} />
      </label>
    </div>
  );
}

ToggleButtonOnOff.propTypes = {
  value: PropTypes.bool,
  id: PropTypes.string,
  onMessage: PropTypes.string,
  offMessage: PropTypes.string,
  /** When set (e.g. admin affirmation-prompts base URL), PATCH `${base}/${id}` with { isActive } + Bearer token instead of user toggle-change. */
  adminPatchBaseUrl: PropTypes.string,
  onToggleSuccess: PropTypes.func,
  /** Return false to block the toggle before the confirm dialog opens. */
  beforeToggle: PropTypes.func,
};
ToggleButtonOnOff.defaultProps = {
  value: false,
  id: null,
  onMessage: 'Are you sure you want to change status?',
  offMessage: 'Are you sure you want to change status?',
  adminPatchBaseUrl: null,
  onToggleSuccess: null,
  beforeToggle: null,
};
export default ToggleButtonOnOff;
